<xm-display-card>
    <div class="current-cycle">
        <h3>{{ pageData.header }}</h3>
        <div class="content">
            <xm-media-image aria-hidden="true" [imageOptions]="imageOptions" size="height" center="hoz"></xm-media-image>
            <div class="details">
                <h2>{{ pageData.subheader }}</h2>
                <p class="description-text">{{ pageData.description }}</p>
            </div>
            <div class="links">
                <a uiSref="account.settings.level-move.landing" class="xm-btn-secondary-light">{{ pageData.buttonText }}</a>
            </div>
        </div>
    </div>
</xm-display-card>
